import React, { Component } from 'react';
import { observer } from 'mobx-react';
import WebPageForm from './WebPageForm';
import WebPageFormService from '../services/WebPageFormService';

class WebPageFormContainer extends Component {
  webPageFormService = new WebPageFormService();
  componentWillMount() {
    this.webPageFormService.handleLoad();
  }

  render() {
    return (
      <WebPageForm
        onSubmit={this.webPageFormService.handleSubmit}
        onChange={this.webPageFormService.form.setValue}
        onReset={this.webPageFormService.form.reset}
        values={this.webPageFormService.form.getValues()}
        errors={this.webPageFormService.form.errors}
        submitting={this.webPageFormService.submit.fetching || this.webPageFormService.fetch.fetching}
        error={this.webPageFormService.submit.error}
        isDirty={this.webPageFormService.form.isDirty}
      />
    );
  }
}

export default observer(WebPageFormContainer);
